import styled from '@emotion/styled';
import { Div } from '../../layouts';

export const RoomSelectorDesktopEl = styled(Div)`
    .odf-rtl && {
      left: 0;
      right: auto;
    }
    && {
        right: 0;
        width: 300px;
    }
`;
